import { render, staticRenderFns } from "./addAttribute.vue?vue&type=template&id=5e8716e8&scoped=true&"
import script from "./addAttribute.vue?vue&type=script&lang=js&"
export * from "./addAttribute.vue?vue&type=script&lang=js&"
import style0 from "./addAttribute.vue?vue&type=style&index=0&id=5e8716e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8716e8",
  null
  
)

component.options.__file = "addAttribute.vue"
export default component.exports